import Keycloak from "keycloak-js";
import { constants } from "../consts/Variables";

let isRefreshing = false;

export const keycloak = new Keycloak({
  url:
    process.env.NODE_ENV === "development"
      ? // ? "https://xr3learn-keycloak.lab.synelixis.com/"
        process.env.REACT_APP_KEYCLOAK
      : constants.AUTH_URL,
  realm:
    process.env.NODE_ENV === "development" ? "XR2Learn" : constants.AUTH_REALM,
  clientId:
    process.env.NODE_ENV === "development"
      ? "marketplace"
      : constants.AUTH_CLIENT,
  clientSecret:
    process.env.NODE_ENV === "development"
      ? "**********"
      : constants.AUTH_CLIENT_SECRET,
  enableCors: true,
});

export const onLogin = () => {
  keycloak.login({ redirectUri: window.location.origin + "/" });
};

export const onLogout = () => {
  localStorage.removeItem("kc_token");
  keycloak.logout({ redirectUri: window.location.origin + "/" });
};

const startTokenRefresh = () => {
  setInterval(async () => {
    if (isRefreshing) return;
    isRefreshing = true;

    try {
      const refreshed = await keycloak.updateToken(30);
      if (refreshed) {
        localStorage.setItem("kc_token", keycloak.token);
      }
    } catch (error) {
      console.error("Token refresh failed", error);
      onLogin();
    } finally {
      isRefreshing = false;
    }
  }, 60000);
};

export const onUpdateTokenWithKeycloak = async () => {
  keycloak
    .updateToken(30)
    .then(() => {
      localStorage.setItem("kc_token", keycloak.token);
    })
    .error((error) => {
      console.log(error);
    });
};

export const onLoadUser = async () => {
  return keycloak
    .loadUserProfile()
    .then((profile) => {
      localStorage.setItem("user", JSON.stringify(profile));
    })
    .catch((error) => {
      console.log(error);
    });
};

keycloak.onAuthLogout = function () {
  localStorage.removeItem("kc_token");
};

keycloak.onAuthSuccess = function () {
  localStorage.setItem("kc_token", keycloak.token);
  onLoadUser();
  startTokenRefresh();
};
